<template>
  <div class="clearfix e-flex" style="text-align: left">
    <el-upload
      ref="innerUpload"
      class="upload-demo"
      :action="actionUrl"
      :data="actionData"
      :limit="limit"
      :show-file-list="showFileList"
      :on-success="handleUploadSuccess"
      :on-progress="handleUploadProgress"
      :on-error="handleUploadError"
      :before-upload="beforeAvatarUpload"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :accept="accept"
    >
      <!-- 触发器可通过 trigger 插槽自定义（如 CA 模块的图标按钮）；不传则沿用原按钮 -->
      <slot name="trigger">
        <el-button size="small" type="primary" plain>{{ uploadTitle }}</el-button>
      </slot>
      <div slot="tip" class="el-upload__tip">
        <slot name="explain"></slot>
      </div>
    </el-upload>
  </div>
</template>
<script>
import { queryByFileId } from '../../api/upload'
import { download } from '@/shared/file'

export default {
  data() {
    return {
      actionData: {
        module1: 'bfe',
        module2: 'bfe_guarantee_main',
      },
      fileList: [],
    }
  },
  props: {
    limit: {
      default: 1,
      type: Number,
    },
    actionUrl: {
      default: 'zcjf/base/file/upload',
      type: String,
    },
    uploadTitle: {
      default: 'upload',
      type: String,
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    // 用户父组件-》子组件时获取fileName回显
    fileId: {
      type: String,
      default: '',
    },
    filetypes: {
      default: () => [
        'png',
        'docx',
        'doc',
        'rar',
        'zip',
        'jpg',
        'bmp',
        'gif',
        'pdf',
        'jpeg',
      ],
      type: Array,
    },
    maxSize: {
      type: Number,
      default: () => 1073741824,
    },
    accept: {
      type: String,
      default() {
        // 服务器限制只支持一下文件类型，必须为小写
        return '.doc, .docx, .ppt, .pptx, .xls, .xlsx, .pdf, .rtf, .png, .jpg, .jpeg, .gif, .rar, .zip, .gzip, .tar, .xml, .xsl, .txt, .etnd, .bmp, .tif'
      }
    },
    // 是否使用 el-upload 自带的文件列表。
    // 默认 true 不影响现有调用方；CA 模块上传成功后自己渲染「文件名 + 操作按钮」，传 false
    showFileList: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    fileId(file) {
      if (!file || this.filetypes.some((s) => file.endsWith(s))) return
      queryByFileId({ fileId: file }).then((res) => {
        if (res.data) {
          this.fileList = []
          this.fileList.push({
            name: res.data.fileName,
            fileId: res.data.fileId,
          })
        }
      })
    },
  },
  mounted() {
    if (!this.fileId || this.filetypes.some((s) => this.fileId.endsWith(s))) { return }
    queryByFileId({ fileId: this.fileId }).then((res) => {
      if (res.data) {
        this.fileList = []
        this.fileList.push({
          name: res.data.fileName,
          fileId: res.data.fileId,
        })
      }
    })
  },
  methods: {
    handleExceed() {
      this.$message.warning(
        '上传超过限制，只能上传' + this.limit + '个文件，请删除当前文件后操作'
      )
    },
    handlePreview(file) {
      console.log(file)
      if (file.status === 'success') {
        if (file.response) {
          download(file.response.url)
        } else {
          download(file.fileId)
        }
      }
    },
    // 文件移除钩子，用于清理fileId
    handleRemove(file, fileList) {
      this.$emit('fileIdCb', { url: '' })
    },
    // 文件上传成功钩子函数
    handleUploadSuccess(res, file) {
      // 后端业务失败也返回 HTTP 200（如 0KB 文件返回 {status:0, message}），
      // el-upload 只认 HTTP 状态码会走 on-success，必须按响应体判断。
      // 失败时还要把该文件清出内部 uploadFiles，否则受 limit=1 拦截
      // 无法重新上传，而 CA 场景自渲染列表此时无删除入口，页面会卡死
      if (!res || !res.url) {
        this.$message.error((res && res.message) || '上传失败')
        const uploadFiles = this.$refs.innerUpload.uploadFiles
        const idx = uploadFiles.indexOf(file)
        if (idx > -1) uploadFiles.splice(idx, 1)
        this.$emit('uploadError', res)
        return
      }
      this.$message.success('上传成功')
      this.$emit('fileIdCb', res)
    },
    // 上传进度回调（element-ui on-progress 触发，percent 为 0-100 的数值）
    handleUploadProgress(event) {
      const percent =
        event && typeof event.percent === 'number'
          ? Math.min(100, Math.max(0, Math.round(event.percent)))
          : 0
      this.$emit('uploadProgress', percent)
    },
    // 上传失败（HTTP 层错误，如网络中断 / 网关 413 等）：提示并清理失败文件，
    // 否则受 limit=1 拦截无法重新上传
    handleUploadError(err, file) {
      this.$message.error('上传失败，请重试')
      const uploadFiles = this.$refs.innerUpload.uploadFiles
      const idx = uploadFiles.indexOf(file)
      if (idx > -1) uploadFiles.splice(idx, 1)
      this.$emit('uploadError', err)
    },
    // 文件上传拦截
    beforeAvatarUpload(file) {
      if (!file.size) {
        this.$message.error('上传文件大小为空！')
        return false
      }
      if (file.size > this.maxSize) {
        this.$message.error('上传文件大小超过限制！请上传小于' + this.maxSize / 1024 / 1024 + 'MB大小的文件')
        return false
      }
      let fileType = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()

      if (this.filetypes.indexOf(fileType) === -1) {
        this.$message.error('上传文件格式不正确')
        return false
      }
      this.$emit('uploadStart')
    },
    // 清空内部文件列表：父组件「自渲染删除」后必须调一次，
    // 否则内部仍计 1 个文件，受 limit=1 拦截无法重新上传
    clearFiles() {
      this.$refs.innerUpload.clearFiles()
    },
  },
}
</script>

<style scoped>
.upload-demo {
  width: 100%;
  overflow: hidden;
}
</style>
